import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IFetchSpeakerVoicesPayload,
  IUpdateSpeakerVoicePayload,
  IRemoveSpeakerVoicesFromWorkspacePayload,
  ICreateSpeakerVoicePayload,
  IGenerateDesignSamplePayload,
  IGenerateDesignSampleJobResponseBody,
  IGenerateDesignSampleJobStatusResponseBody,
} from './types'

const config: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
  }
}

export function fetch(payload: IFetchSpeakerVoicesPayload) {
  return axios.get(`/api/v1/speaker_voices/`, { params: convertToSnakeCase(payload) })
}

export function fetchLanguages() {
  return axios.get(`/api/v1/speaker_voices/get_languages`)
}

export function update(payload: IUpdateSpeakerVoicePayload) {
  const processedPayload = Object.entries(payload).reduce<Record<string, any>>((acc, [key, value]) => {
    acc[key] = value === undefined ? null : value
    return acc
  }, {})

  return axios.put(`/api/v1/speaker_voices/${payload.id}`, convertToSnakeCase(processedPayload), config)
}

export function removeFromWorkspace(payload: IRemoveSpeakerVoicesFromWorkspacePayload) {
  return axios.post(`/api/v1/speaker_voices/remove_from_workspace`, convertToSnakeCase(payload), config)
}

export function createSpeakerVoice(payload: ICreateSpeakerVoicePayload) {
  return axios.post(`/api/v1/speaker_voices/`, convertToSnakeCase(payload), config)
}

export function generateDesignSample(payload: IGenerateDesignSamplePayload) {
  return axios.post<IGenerateDesignSampleJobResponseBody>(`/api/v1/speaker_voices/generate_design_sample`, convertToSnakeCase(payload), config)
}

export function getDesignSampleJob(workspaceId: number, jobId: string) {
  return axios.get<IGenerateDesignSampleJobStatusResponseBody>(`/api/v1/speaker_voices/design_sample_jobs/${jobId}`, {
    params: { workspace_id: workspaceId }
  })
}
